import {
	ADD_IMPORT_CLIENT,
	ADD_IMPORT_SECTOR,
	GET_ALL_CLIENT,
	GET_ALL_RETAILER,
	ADD_IMPORT_KPI,
	ADD_IMPORT_ASSORTMENTS,
} from "./../types";

import { createReducer, createApiHandlers } from "./functions";

const initialState = {
	reponseImportClient: [],
	reponseImportAssortments: [],
	reponseImportSector: [],
	reponseImportKpi: [],
	clientsList: [],
	retailersList: [],
};

const addImportAssortmentsHandlers = createApiHandlers(
	ADD_IMPORT_ASSORTMENTS,
	(state, action) => {
		return { ...state, reponseImportAssortments: action.payload.data };
	}
);
const addImportSectorsHandlers = createApiHandlers(
	ADD_IMPORT_SECTOR,
	(state, action) => {
		return { ...state, reponseImportSector: action.payload.data };
	}
);

const addImportClientsHandlers = createApiHandlers(
	ADD_IMPORT_CLIENT,
	(state, action) => {
		return { ...state, reponseImportClient: action.payload.data };
	}
);

const addImportKpisHandlers = createApiHandlers(
	ADD_IMPORT_KPI,
	(state, action) => {
		return { ...state, reponseImportKpi: action.payload.data };
	}
);
const getAllClientsHandlers = createApiHandlers(
	GET_ALL_CLIENT,
	(state, action) => {
		return { ...state, clientsList: action.payload.data };
	}
);

const getAllRetailersHandlers = createApiHandlers(
	GET_ALL_RETAILER,
	(state, action) => {
		return { ...state, retailersList: action.payload.data };
	}
);

const clientReducer = createReducer(initialState, {
	...addImportClientsHandlers,
	...getAllClientsHandlers,
	...addImportSectorsHandlers,
	...addImportAssortmentsHandlers,
	...getAllRetailersHandlers,
	...addImportKpisHandlers,
});
export default clientReducer;



// WEBPACK FOOTER //
// src/redux/reducers/clientReducer.js